import React from 'react';
import { Recycle, TrendingUp, Eye, Users, Leaf, Award } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Card } from '../components/ui/card';

const WhyUs = () => {
  const { t } = useLanguage();

  const iconMap = {
    0: Recycle,
    1: TrendingUp,
    2: Eye,
    3: Users,
    4: Leaf,
    5: Award
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section
        style={{
          padding: '8rem 1.5rem 4rem',
          background:
            'radial-gradient(at 50% 30%, hsla(108,100%,50%,0.2) 0px, transparent 50%)',
          textAlign: 'center'
        }}
      >
        <div className="max-w-4xl mx-auto">
          <h1
            style={{
              fontWeight: 700,
              fontSize: 'clamp(2.25rem, 5vw, 4rem)',
              lineHeight: 0.9,
              letterSpacing: '-0.02em',
              color: 'rgb(0, 55, 32)',
              marginBottom: '1.5rem'
            }}
          >
            {t.whyChoose.title}
          </h1>
          <p
            style={{
              fontSize: 'clamp(1.125rem, 2.5vw, 1.25rem)',
              lineHeight: 1.5,
              color: 'rgb(131, 146, 140)',
              maxWidth: '700px',
              margin: '0 auto'
            }}
          >
            {t.whyChoose.subtitle}
          </p>
        </div>
      </section>

      {/* Reasons Grid */}
      <section
        style={{
          padding: '4rem 1.5rem 6rem',
          background: 'white'
        }}
      >
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {t.whyChoose.reasons.map((reason, index) => {
              const Icon = iconMap[index];
              return (
                <Card
                  key={index}
                  className="product-card"
                  style={{
                    background: 'white',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    borderRadius: '12px',
                    padding: '2rem',
                    transition: 'all 0.2s ease',
                    cursor: 'pointer',
                    position: 'relative',
                    overflow: 'hidden',
                    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
                  }}
                >
                  <div
                    style={{
                      width: '56px',
                      height: '56px',
                      background: 'rgba(148, 242, 127, 0.1)',
                      borderRadius: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '1.5rem'
                    }}
                  >
                    <Icon size={28} style={{ color: 'rgb(13, 121, 22)' }} />
                  </div>
                  <h3
                    className="product-card-title"
                    style={{
                      fontWeight: 600,
                      fontSize: '1.125rem',
                      lineHeight: 1.3,
                      marginBottom: '0.75rem',
                      color: 'rgb(0, 55, 32)'
                    }}
                  >
                    {reason.title}
                  </h3>
                  <p
                    className="product-card-description"
                    style={{
                      fontSize: '0.875rem',
                      lineHeight: 1.6,
                      color: 'rgb(131, 146, 140)',
                      margin: 0
                    }}
                  >
                    {reason.description}
                  </p>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Additional CTA */}
      <section
        style={{
          padding: '4rem 1.5rem 5rem',
          background: 'rgba(0, 0, 0, 0.02)',
          textAlign: 'center'
        }}
      >
        <div className="max-w-3xl mx-auto">
          <h2
            style={{
              fontWeight: 600,
              fontSize: 'clamp(1.875rem, 4vw, 2.5rem)',
              lineHeight: 1,
              color: 'rgb(0, 55, 32)',
              marginBottom: '1rem'
            }}
          >
            {t.nav.home === 'Home'
              ? 'Ready to Partner with BMPS?'
              : 'Siap Bermitra dengan BMPS?'}
          </h2>
          <p
            style={{
              fontSize: '1.125rem',
              lineHeight: 1.6,
              color: 'rgb(131, 146, 140)',
              marginBottom: '2rem'
            }}
          >
            {t.nav.home === 'Home'
              ? 'Join us in creating a sustainable future through innovative recycling solutions.'
              : 'Bergabunglah dengan kami dalam menciptakan masa depan berkelanjutan melalui solusi daur ulang inovatif.'}
          </p>
          <button
            className="btn-primary"
            style={{
              background: 'linear-gradient(to bottom right, #8FEC78, #81DD67)',
              color: 'white',
              border: 'none',
              borderRadius: '9999px',
              padding: '14px 32px',
              fontWeight: 600,
              fontSize: '1rem',
              minHeight: '48px',
              cursor: 'pointer',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'scale(1.02)';
              e.target.style.boxShadow = '0px 4px 8px rgba(148, 242, 127, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'scale(1)';
              e.target.style.boxShadow = 'none';
            }}
          >
            {t.nav.contact === 'Contact' ? 'Contact Us Today' : 'Hubungi Kami Hari Ini'}
          </button>
        </div>
      </section>
    </div>
  );
};

export default WhyUs;